import type { AnyElementKey } from '../test-utils';

const NON_SCRUBBED_NODE_PROPERTIES = ['type'] satisfies AnyElementKey[];
const NON_SCRUBBED_PROPERTIES = [...NON_SCRUBBED_NODE_PROPERTIES, 'originType'];

/**
 * A scrubber function that can be used with Slate's scrubber feature or as the second argument of
 * JSON.stringify. Replaces any string properties with '#' characters matching the length of the
 * string, with the exception of allowed properties such as type.
 *
 * This is important to avoid leaking personal or confidential information to Sentry, which might
 * violate Aline's privacy policy and any confidentiality agreements with its customers. Personal
 * information can include the text content of the document, but also some node properties such as
 * a link element's href property that uses mailto: or tel:.
 *
 * To be safe, all properties are masked by default, but it's generally safe to add new properties
 * to NON_SCRUBBED_PROERTIES so long as these properties do not contain user-generated text content.
 */
export function scrubber(key: string, value: unknown): unknown {
  const scrubKey =
    typeof value === 'string' &&
    !/^[0-9]+$/.test(key) && // Do not scrub array elements
    !NON_SCRUBBED_PROPERTIES.includes(key);

  return scrubKey ? '#'.repeat(value.length) : value;
}
